import "slick-carousel";

class Slider {
  speed = 1000;
  constructor($el) {
    this.$el = $el;
    this.$sliderLeft = this.$el.find('[data-slider="left"]');
    this.$sliderRight = this.$el.find('[data-slider="right"]');
    this.$next = this.$el.find('[data-slider="next"]');
    this.init();
  }

  init() {
    this.$sliderLeft.slick({
      arrows: false,
      dots: true,
      swipe: true,
      speed: this.speed,
      asNavFor: this.$sliderRight,
    });

    this.$sliderRight.slick({
      arrows: false,
      dots: false,
      swipe: true,
      asNavFor: this.$sliderLeft,
      speed: this.speed,
    });

    this.$next.on("click", () => {
      this.$sliderRight.slick("slickNext");
    });
  }
}

export default Slider;
